import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
// Remove any service worker left over from older versions so visitors always get the latest build.
unregister();



// WEBPACK FOOTER //
// ./src/index.js